(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-contact"] && !Shopify.designMode) return;
  try {
    

  $('.contact-button').prop("disabled", false);
$('input:checkbox.checks').click(function() {
 if ($(this).is(':checked')) {
    $('.contact-button').prop("disabled", true);
 } else {
  if ($('.checks').filter(':checked').length < 1){
 $('.contact-button').attr('disabled',false);}
 }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-faq"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
     
    });
    $('.answer').slideUp(200);
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-followers"] && !Shopify.designMode) return;
  try {
    

  $('.js-follower').slick({
  centerMode: true,
  centerPadding: '0',
  slidesToShow: 3,
  responsive: [
 {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '36px',
        slidesToShow: 1
      }
    }
  ]
});
			

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-ui-faq"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  var answers = document.querySelectorAll('.answer');
  var questionHeadings = document.querySelectorAll('.question-heading');

  for (var i = 0; i < answers.length; i++) {
    answers[i].style.display = 'none';
  }

  for (var i = 0; i < questionHeadings.length; i++) {
    questionHeadings[i].addEventListener('click', function() {
      var answer = this.nextElementSibling;
      answer.style.display = (answer.style.display === 'none') ? 'block' : 'none';
      this.classList.toggle('expanded');
    });
  }

  for (var i = 0; i < answers.length; i++) {
    answers[i].style.display = 'none';
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-ui-stylesheet"] && !Shopify.designMode) return;
  try {
    


// Magic ATC

document.addEventListener("DOMContentLoaded",()=>{
    document.querySelectorAll('[data-pf-type="ProductATC"]').forEach(button=>{
        if (button.getAttribute("data-product.available")=="false") {
            button.innerText=button.getAttribute("data-soldout");
            return;
        }
        button.addEventListener("click",(event)=>{
            event.preventDefault();
            doATC(button);
        });
    });
});

function doATC(el) {
    el.innerText = el.getAttribute("data-adding");
    window.fetch("/cart/add.js",{
        method:"POST",
        credentials:"same-origin",
        headers:{
          "content-type":"application/json"
        },
        body:JSON.stringify({
            id:el.getAttribute("data-product-id"),
            quantity:1,
        })
    })
    .then(response=>response.json())
    .then(json=>{
        el.innerText = el.getAttribute("data-added");
        document.dispatchEvent(new CustomEvent(el.getAttribute("data-callback"),{bubbles:true}));
    });
}
  document.addEventListener("atc:gocart",()=>goCart.fetchAndOpenCart());
  document.addEventListener("atc:smartcart",()=>Rebuy.SmartCart.show());
  document.addEventListener("atc:checkout",()=>location.href="/checkout");
  document.addEventListener("atc:cartpage",()=>location.href="/cart");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});


  } catch(e) { console.error(e); }
})();
})();
